<template>
  <bound-view :trainer="trainer" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import BoundView from '@/components/trainer/BoundView';
import { ROUTE_TRAINER_VIEW } from '@/router/names';

const { mapState } = createNamespacedHelpers('trainer');

export default {
    computed: {
        ...mapState({
            trainer: state => state.trainer || {},
        }),
    },
    mounted() {
        const { id } = this.$route.params;
        if (this.trainer.id !== Number.parseInt(id, 10) || !this.trainer.wechat_bound) {
            this.$router.replace({
                name: ROUTE_TRAINER_VIEW,
                params: {
                    id,
                },
            });
        }
    },
    components: {
        BoundView,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer/BoundView.vue